/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { generateDocsUrl } from '../../../ia/util/docs';

export const links = {
  DEVELOPER_LINK:
    'https://integrations.us-south.assistant.watson.cloud.ibm.com/web/developer-documentation/',
  EMBED_LINK:
    'https://web-chat.global.assistant.watson.cloud.ibm.com/docs.html?to=api-configuration',
  learnMoreConfigLinkNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-web-chat-develop'
  ),
  learnMoreConfigLinkClassic: generateDocsUrl(
    '/?topic=assistant-web-chat-config'
  ),
  learnMoreDeployLink: generateDocsUrl('/?topic=assistant-deploy-web-chat'),
  learnMoreLauncherLinkClassic: generateDocsUrl(
    '/?topic=assistant-deploy-web-chat#deploy-web-chat-launcher'
  ),
  learnMoreLauncherLinkNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-web-chat-architecture#web-chat-architecture-launcher'
  ),
  learnMoreHomeScreenLinkClassic: generateDocsUrl(
    '/?topic=assistant-deploy-web-chat#deploy-web-chat-home-screen'
  ),
  learnMoreHomeScreenLinkNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-web-chat-configure-home-screen'
  ),
  learnMoreLiveAgentLinkClassic: generateDocsUrl(
    '/?topic=assistant-deploy-web-chat#deploy-web-chat-haa'
  ),
  learnMoreLiveAgentLinkNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-web-chat-haa'
  ),
  learnMoreSecurityLinkClassic: generateDocsUrl(
    '/?topic=assistant-web-chat-security'
  ),
  learnMoreSecurityLinkNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-web-chat-security'
  ),
  learnMoreSuggestionsLinkClassic: generateDocsUrl(
    '/?topic=assistant-deploy-web-chat#deploy-web-chat-alternate'
  ),
  learnMoreSuggestionsLinkNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-web-chat-suggestions'
  ),
  securityIBMPublickKeyLink: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-web-chat-security-encrypt'
  ),
  securityPublickKeyLink: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-web-chat-security-enable#web-chat-security-enable-prereq'
  ),
  ResourcesDemoSiteTileLink:
    'https://www.ibm.com/products/watson-assistant/demos/lendyr/demo.html',
  ResourcesDocsTutorialTileLink:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-web-chat-overview',
  webchatOverviewTileLink:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-web-chat-overview',
  embedWebchatTileLink:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-deploy-web-chat',
  addingLiveAgentTileLink:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-deploy-web-chat-haa',
  styleWebchatTileLink:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-web-chat-style',
  setUpHomeScreenTileLink:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-web-chat-configure-home-screen',
  setUpSuggestionTileLink:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-web-chat-suggestions',
  developmentOverviewTileLink:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-web-chat-develop',
  downloadableTranscriptTileLink:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-web-chat-develop-download-transcript',
  implementingCustomButtonsTileLink:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-web-chat-develop-custom-buttons',
  supportingGlobalAudiencesTileLink:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-web-chat-develop-global',
  versioningTileLink:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-web-chat-develop-versions',
  securityTileLink:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-web-chat-security',
  userIdentityTileLink:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-web-chat-develop-userid',
  webchatMobileLink:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-web-chat-develop-mobile',
  lendyrDemoLink:
    'https://www.ibm.com/products/watson-assistant/demos/lendyr/demo.html?section=essentials',
  lendyrJourneysLink:
    'https://www.ibm.com/products/watson-assistant/demos/lendyr/demo.html?section=index&panel=journeys',
  lendyrThemingLink:
    'https://www.ibm.com/products/watson-assistant/demos/lendyr/demo.html?section=index&panel=theming',
  lendyrDeepLinkingLink:
    'https://www.ibm.com/products/watson-assistant/demos/lendyr/demo.html?page=email&section=index&panel=deep-linking',
  webchatSetContextLink:
    ' https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-web-chat-develop-set-context',
  webchatPageInteractionLink:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-web-chat-develop-page-interaction',
  developContentCarouselLink:
    ' https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-web-chat-develop-content-carousel'
};
